module.exports = __webpack_public_path__ + "img/vertical_7_7_4.6e24e708.png";